import { render } from "./SignatureModal.vue?vue&type=template&id=2d15f7d8&scoped=true"
import script from "./SignatureModal.vue?vue&type=script&lang=js"
export * from "./SignatureModal.vue?vue&type=script&lang=js"

import "./SignatureModal.vue?vue&type=style&index=0&id=2d15f7d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d15f7d8"]])

export default __exports__